import { logger } from '@vista/omnichannel-components-domain';
import { TicketRedemptionCodeFormActionType as ActionType } from '../types/action-type';
import { defaultTicketRedemptionCodeFormState as defaultState } from '../types/state';
export const ticketRedemptionCodeFormActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.SetFormData:
            return Object.assign(Object.assign({}, state), { formData: action.formData });
        case ActionType.SetTypeHasBeenManuallySet:
            return Object.assign(Object.assign({}, state), { hasTypeBeenManuallySet: true });
        case ActionType.SetDetectedType: {
            if (state.hasTypeBeenManuallySet)
                return state;
            return Object.assign(Object.assign({}, state), { formData: Object.assign(Object.assign({}, state.formData), { typeId: action.typeId }) });
        }
        case ActionType.SetFormSubmittingState:
            return Object.assign(Object.assign({}, state), { isSubmitting: action.isSubmitting });
        case ActionType.SetHelpText:
            return Object.assign(Object.assign({}, state), { helpTextsById: Object.assign(Object.assign({}, state.helpTextsById), { [action.helpText.id]: action.helpText }) });
        case ActionType.Reset:
            return defaultState;
        default: {
            logger.error(`Unknown TicketRedemptionCodeFormAction ${action.type}.`);
            return state;
        }
    }
};
